import { render } from "./vote-buttons.vue?vue&type=template&id=7da7e5b2"
import script from "./vote-buttons.vue?vue&type=script&lang=js"
export * from "./vote-buttons.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__